// context/index.tsx
import React, { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';

// Static imports instead of require.context for test compatibility
import { MiaChatProvider } from './MiaChatContext';
import { SocketProvider } from 'app/context/SocketContext';
import { AIAvatarThemeProvider } from './ThemeContext';
import { SummarizationProvider } from 'app/context/SummarizationContext';
import { selectDealerSelected } from '../redux/headerSlice/selectors';

const SummarizationProviderWithDealer: React.FC<{ children: React.ReactNode }> = (props) => {
  const selectedDealer = useSelector(selectDealerSelected);
  const dealerId = selectedDealer?.dealer ?? '';
  return React.createElement(SummarizationProvider, { dealerId, children: props.children });
};

const providers: React.FC<{ children: React.ReactNode }>[] = [
  MiaChatProvider,
  SocketProvider,
  AIAvatarThemeProvider,
  SummarizationProviderWithDealer,
];

const AppProvider: React.FC<{ children: ReactElement; }> = ({ children }) => {
  const tree = useMemo(() => {
    return providers.reduceRight<ReactElement>(
      (acc, Provider) => React.createElement(Provider, { children: acc }),
      children
      );
  }, [children]); // you can include `providers` in deps if it ever changes

  return tree;
};

export default AppProvider;